import { X, Check } from 'lucide-react';
import { Reveal, Eyebrow, H2 } from './shared';

export const LeftOutSection = () => (
  <Reveal as="section" className="bg-background text-v2-ink py-16 md:py-24">
    <div className="container mx-auto px-5 max-w-6xl">
      <Eyebrow>O que fica de fora</Eyebrow>
      <H2 className="max-w-2xl">O vilão não é a sua pele. É o perfume.</H2>
      <p className="mt-4 max-w-xl text-v2-muted">
        Perfume é a causa mais comum de irritação de contato. Então a gente simplesmente não coloca.
      </p>
      <div className="mt-10 grid md:grid-cols-2 gap-4">
        <div className="rounded-2xl border border-v2-ink/10 bg-v2-bg p-6">
          <h3 className="font-narrow text-xl font-semibold mb-4">Muitos cremes “para pele sensível”</h3>
          <ul className="space-y-3 text-base">
            {['Perfume “suave” ou “hipoalergênico”', 'Óleos essenciais apresentados como gentis', '“Dermatologicamente testado” sem dizer qual teste'].map((t) => (
              <li key={t} className="flex gap-2"><X className="w-4 h-4 mt-0.5 shrink-0 text-v2-pes" />{t}</li>
            ))}
          </ul>
        </div>
        <div className="rounded-2xl bg-v2-ink text-v2-bg p-6">
          <h3 className="font-narrow text-xl font-semibold mb-4">Hidratantes NAT HOF</h3>
          <ul className="space-y-3 text-base">
            {['Sem perfume', 'Livres de parabenos', 'Teste de contato repetido (HRIPT), com nome'].map((t) => (
              <li key={t} className="flex gap-2"><Check className="w-4 h-4 mt-0.5 shrink-0 text-v2-bal" />{t}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </Reveal>
);
